module.exports = __webpack_public_path__ + "img/image-2.7496255a.png";